import React from 'react';
import {connect} from 'react-redux';
import MainWrapper from "../../components/live/MainWrapper";
import MainTable from "../../components/live/MainTable";

const LivePage = (props) => {

    return (
        <MainWrapper>
            <MainTable {...props}/>
        </MainWrapper>

    )
};

const mapStateToProps = state => ({
    drawResult: state.result.draw
});


export default connect(
    mapStateToProps,
    {}
)(LivePage);
